import * as React from 'react';
import { useState, useEffect, useRef, useReducer } from 'react';
import { bdAxios } from '../../components/utils/Axios';
import { getToken } from '../../components/utils/Common';
//import { useDownloadExcel } from 'react-export-table-to-excel';


interface HumanKey {
    type: string;
    label: string;
    description?: string;
    display_row?: number | string; // or boolean if you prefer
    display_desc?: number | string; // or boolean
    num_row?: string; // if you also want the number column
}

interface ShowOldRatioListProps {
    ratios: any[];
    humanKeys: Record<string, HumanKey>;
    fdata?: any;
}

/**
 * Cleans values for display/export.
 * If the value is "effectively zero" (rounds to 0.00), return an empty string.
 */
const formatExportValue = (val: any) => {
    if (val === null || val === undefined || val === '' || val === '-') {
        return '';
    }

    const num = parseFloat(val);
    
    // Check if it's a number and if it's effectively zero (Option B)
    if (!isNaN(num) && Math.abs(num) < 0.005) {
        return '';
    }

    return val;
};

const ShowOldRatioList: React.FC<ShowOldRatioListProps> = (data) => {
    console.log("VIEW DATA RECEIVED:", data);
    const [ratioLength, setRatioLength] = useState<number>(0);
    const [oldFormData, setOldFormData] = useState<any>();
    const tableRef = useRef<HTMLTableElement>(null);
    const exportTableRef = useRef<HTMLTableElement>(null);

    const exportName = 'Ratios';
    const exportFileName = 'export-ratios';

    const [_, forceUpdate] = useReducer((x) => x + 1, 0);

    useEffect(() => {
        if (data.ratios) setRatioLength(data.ratios.length);
        if (data.fdata) setOldFormData(data.fdata);
        forceUpdate();
    }, [data]);

    /* old code
   const { onDownload } = useDownloadExcel({
        currentTableRef: exportTableRef.current!,
        filename: exportFileName,
        sheet: exportName
    });
    */

    const onDownload = () => {
        // Get the token
        const token = getToken();

        // Validate token is present
        if (!token) {
            alert("Votre session a expiré. Veuillez vous reconnecter.");
            return;
        }
        
        //const baseUrl = `${bdAxios.defaults.baseURL}pme/bd/v1/export-ratio`;
        //const baseUrl = `${bdAxios.defaults.baseURL}pme/bd/v1/ratios/export`;
        const baseUrl = `${bdAxios.defaults.baseURL}ratios/export`;
        const params = new URLSearchParams();

        params.append('token', token); // Authorization
        
       if (data.fdata) {
            Object.keys(data.fdata).forEach(key => {
                const val = data.fdata[key];
                if (Array.isArray(val)) {
                    val.forEach((item: any) => params.append(`${key}[]`, item));
                } else if (val !== undefined && val !== null) {
                    params.append(key, String(val)); //typecast to string just in case
                }
            });
        }

        // Redirect to the PHP download link
        window.location.href = `${baseUrl}?${params.toString()}`;
    };




    const currency = new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' });
    const percent = new Intl.NumberFormat('fr-CA', { maximumSignificantDigits: 3, style: 'percent' });
    const decimal = new Intl.NumberFormat('fr-CA', { maximumSignificantDigits: 3, style: 'decimal' });

    const currency_export = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'USD',
        useGrouping: false
    });
    const number_export = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
        useGrouping: false
    });
    const number_display = new Intl.NumberFormat('fr-CA', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        useGrouping: false
    });

    const float_export = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
        useGrouping: false
    });

    const percent_export = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'percent'
    });

  

     const decimal_export = new Intl.NumberFormat('en-US', {minimumFractionDigits: 2,
        maximumFractionDigits: 2, useGrouping: false, style: 'decimal' });

     const date_export = (rawVal?: string | number) => {
        if (!rawVal) return '';

        let dateStr = rawVal.toString(); // e.g. "2024-02-09120411" or "0000-00-00 00:00:00"

        // Handle "0000-00-00 00:00:00"
        if (dateStr === '0000-00-00 00:00:00') return ''; 
        

        // Match: YYYY-MM-DDHHMMSS
        const match = dateStr.match(/^(\d{4}-\d{2}-\d{2})(\d{2})(\d{2})(\d{2})$/);
        if (match) {
            const [, ymd, hh, mm, ss] = match;
            return `${ymd} ${hh}:${mm}:${ss}`;
        }

        // Match: YYYY-MM-DD HH:MM:SS (already valid)
        const match2 = dateStr.match(/^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2}):(\d{2})$/);
        if (match2) return dateStr;

        return dateStr; // fallback if format is unknown
        };


    

    return (
        <div className="old-ratio old-ratio-list">

            <button className="button back" onClick={onDownload}>Exporter</button>

            {/* Visible human table */}
            <table ref={tableRef}>
                <thead>
                    <tr>
                        <td></td>
                        <td></td>
                        {data.ratios.map((ratio: any, i: number) => (
                            <th className="value-only" key={i} data-key={Math.random()}>
                                {ratio.colonne}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.humanKeys && Object.keys(data.humanKeys).map((key: string) => {
                         if (Number(data.humanKeys[key].display_row) === 0) return null;
                        let canSkip = true;

                        if (ratioLength > 0) {
                            data.ratios.forEach((ratio: any) => { if (ratio[key]) canSkip = false; });
                        }
                        if (data.humanKeys[key].type === 'title') canSkip = false;
                        if (['nom_utilisateur', 'complete'].includes(key)) canSkip = true;
                        if (canSkip) return null;

                        if (data.humanKeys[key].type === 'title') {
                            return (
                                <tr key={key}>
                                    <td></td>
                                    <th className="key-name" title={data.humanKeys[key].description} colSpan={ratioLength + 1}>
                                        {data.humanKeys[key].label}
                                    </th>
                                </tr>
                            );
                        }

                        return (
                            <tr key={key}>
                                <td  className="key-name">{data.humanKeys[key].num_row}</td>
                                <td
                                    className="key-name"
                                    title={data.humanKeys[key].description}
                                    style={{ whiteSpace: 'pre-wrap', verticalAlign: 'top' }}
                                    >
                                    {data.humanKeys[key].label}
                                    {Number(data.humanKeys[key].display_desc) === 1
                                        ? `\n* ${data.humanKeys[key].description}`
                                        : ''}
                                </td>
                                {data.ratios.map((ratio: any, colIndex: number) => {
                                    let val = ratio[key];
                                    let strVal = '';
                                    if (formatExportValue(val) === '') {
                                        strVal = '';
                                    } else {
                                        switch (data.humanKeys[key].type) {
                                            case 'currency':
                                                strVal = currency_export.format(val);
                                                break;
                                            case 'percent':
                                                strVal = percent_export.format(val);
                                                break;
                                            case 'number':
                                                strVal = number_display.format(val);
                                                break;
                                            case 'float':
                                                strVal = decimal_export.format(val);
                                                break;
                                            case 'year':
                                                strVal = val;
                                                break;
                                        case 'date':
                                                strVal = date_export(val);
                                                break;
                                            case 'string':
                                                strVal = val;
                                                if (strVal.length > 70) strVal = strVal.substr(0, 70) + '…';
                                                break;
                                        }
                                    }
                                    return (
                                        <td key={colIndex} title={ratio[key]} className="value-only">
                                            {strVal}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {/* Hidden export table */}
            <table ref={exportTableRef} style={{ display: 'none' }}>
            <thead>
                <tr>
                <td></td>
                <td></td>
                {/* Added style={{ textAlign: 'right' }} to the column headers */}
                {data.ratios.map((ratio: any, i: number) => (
                    <th key={i} className="value-only" style={{ textAlign: 'right' }}>
                        {ratio.colonne}
                    </th>
                ))}
                </tr>
                
            </thead>
            <tbody>
                {data.humanKeys && Object.keys(data.humanKeys).map((key: string) => {
                if (Number(data.humanKeys[key].display_row) === 0) return null;
                let canSkip = true;

                if (ratioLength > 0) {
                    data.ratios.forEach((ratio: any) => {
                    if (ratio[key]) canSkip = false; // skip only if all falsy
                    });
                }

                if (data.humanKeys[key].type === 'title') canSkip = false;
                if (['nom_utilisateur', 'complete'].includes(key)) canSkip = true;
                if (canSkip) return null;

                if (data.humanKeys[key].type === 'title') {
                    return (
                    <tr key={key}>
                        <th></th>
                        <th
                        className="key-name"
                        colSpan={ratioLength + 1}
                        title={data.humanKeys[key].description}
                        >
                        {data.humanKeys[key].label}
                        </th>
                    </tr>
                    );
                }

                return (
                                        <tr key={key}>
                                            <td  className="key-name">{data.humanKeys[key].num_row}</td>
                                            <td
                                                className="key-name"
                                                title={data.humanKeys[key].description}
                                                style={{ whiteSpace: 'pre-wrap', verticalAlign: 'top' }}
                                                >
                                                {data.humanKeys[key].label}
                                                {Number(data.humanKeys[key].display_desc) === 1
                                                    ? `\n* ${data.humanKeys[key].description}`
                                                    : ''}
                                            </td>
                                            {data.ratios.map((ratio: any, colIndex: number) => {
                                                let val = ratio[key];
                                                let strVal = '';
                                                if (formatExportValue(val) === '') {
                                                    strVal = '';
                                                } else {
                                                    switch (data.humanKeys[key].type) {
                                                        case 'currency':
                                                            strVal = currency_export.format(val);
                                                            break;
                                                        case 'percent':
                                                            strVal = percent_export.format(val);
                                                            break;
                                                        case 'number':
                                                            strVal = number_export.format(val);
                                                            break;
                                                        case 'float':
                                                            strVal = float_export.format(val);
                                                            break;
                                                        case 'year':
                                                            strVal = val;
                                                            break;
                                                        case 'date':
                                                            strVal = date_export(val);
                                                            break;
                                                        case 'string':
                                                            strVal = val;
                                                            if (strVal.length > 70) strVal = strVal.substr(0, 70) + '…';
                                                            break;
                                                    }
                                                }
                                                return (
                                                    <td key={colIndex} title={ratio[key]} className="value-only" style={{ textAlign: 'right' }}>
                                                        {strVal}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                })}
            </tbody>
            </table>


        </div>
    );
}

export default ShowOldRatioList;
